/* ==========================================================================
   WSPR UX pass — assets/wspr-ux.js
   T09: newsletter popup on exit-intent OR 50% scroll (whichever first)
   ========================================================================== */
(function () {
  'use strict';

  function initNewsletterTrigger() {
    var modal = document.querySelector('xo-modal[xo-name^="xo-popup-"]');
    if (!modal) return;

    var fired = false;

    function openPopup() {
      if (fired) return;
      if (modal.hasAttribute('xo-open') && modal.getAttribute('xo-open') !== 'false') {
        fired = true;
        return;
      }
      fired = true;
      modal.setAttribute('xo-open', 'true');
      modal.dispatchEvent(new CustomEvent('xo:open', { bubbles: true }));
    }

    document.addEventListener('mouseleave', function (e) {
      if (window.innerWidth < 990) return;
      if (e.clientY <= 0) openPopup();
    });

    var scrollHandled = false;
    window.addEventListener(
      'scroll',
      function () {
        if (scrollHandled || fired) return;
        var scrollTop = window.scrollY || document.documentElement.scrollTop;
        var docHeight = document.documentElement.scrollHeight - window.innerHeight;
        if (docHeight <= 0) return;
        if (scrollTop / docHeight >= 0.5) {
          scrollHandled = true;
          openPopup();
        }
      },
      { passive: true }
    );
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initNewsletterTrigger();
    });
  } else {
    initNewsletterTrigger();
  }
})();

/* WSPR 30 Sep – product gallery thumbnails respond on the first click.
   The theme treats any pointer movement over the thumbnail strip as a drag and ignores
   thumbnail clicks until the drag's glide animation ends (about 1–2 s). A click that
   moved less than 8px is a click, so the drag flag is cleared before the theme's own
   click/touchend handler runs (document capture phase fires first). */
(function () {
  'use strict';
  var TOL = 8, sx = 0, sy = 0, moved = false;

  function strip(e) {
    return e.target && e.target.closest ? e.target.closest('xo-carousel-thumbnail') : null;
  }
  function start(x, y) { sx = x; sy = y; moved = false; }
  function move(x, y) { if (Math.abs(x - sx) > TOL || Math.abs(y - sy) > TOL) moved = true; }
  function unlock(e) {
    var th = strip(e);
    if (!th || moved) return;
    var lists = th.querySelectorAll('xo-carousel-list');
    for (var i = 0; i < lists.length; i++) lists[i].isThumbMoving = false;
  }

  document.addEventListener('pointerdown', function (e) { if (strip(e)) start(e.clientX, e.clientY); }, true);
  document.addEventListener('pointermove', function (e) { if (e.buttons || e.pointerType === 'touch') move(e.clientX, e.clientY); }, true);
  document.addEventListener('touchstart', function (e) {
    if (strip(e) && e.touches[0]) start(e.touches[0].clientX, e.touches[0].clientY);
  }, { capture: true, passive: true });
  document.addEventListener('touchmove', function (e) {
    if (e.touches[0]) move(e.touches[0].clientX, e.touches[0].clientY);
  }, { capture: true, passive: true });
  document.addEventListener('click', unlock, true);
  document.addEventListener('touchend', unlock, true);
})();

/* WSPR 30 Sep – "Save image as" gives the full-size JPG on product pages.
   Gallery images are served as small WebP files (480px wide on desktop), so saving one gave a
   thumbnail in a format many tools won't open. When the pointer rests on a gallery or zoom image
   (or a finger touches it), the full-size progressive JPG is preloaded and swapped in, so the
   right-click / long-press menu saves that file. Thumbnails are left alone. */
(function () {
  'use strict';
  var SEL = '.main-product img, xo-modal img, xo-gallery img, [class*="lightbox"] img';

  function upgrade(img) {
    if (!img || img.tagName !== 'IMG' || /^(loading|failed)$/.test(img.getAttribute('data-wspr-hd') || '')) return;
    if (!img.matches(SEL) || img.closest('xo-carousel-thumbnail')) return;
    var s = img.currentSrc || img.src;
    if (!s || s.indexOf('/cdn/shop/') === -1) return;
    var u;
    try { u = new URL(s, location.href); } catch (e) { return; }
    ['width', 'height', 'crop'].forEach(function (k) { u.searchParams.delete(k); });
    u.searchParams.set('format', 'pjpg');
    if (s === u.href) return;
    img.setAttribute('data-wspr-hd', 'loading');
    var pre = new Image();
    pre.onload = function () {
      img.removeAttribute('srcset');
      img.removeAttribute('sizes');
      img.src = u.href;
      img.setAttribute('data-wspr-hd', '1');
    };
    pre.onerror = function () { img.setAttribute('data-wspr-hd', 'failed'); };
    pre.src = u.href;
  }

  function onEvt(e) { upgrade(e.target); }
  document.addEventListener('pointerover', onEvt, true);
  document.addEventListener('contextmenu', onEvt, true);
  document.addEventListener('touchstart', onEvt, { capture: true, passive: true });
})();

/* WSPR 30 Sep – product image viewer without zoom. The theme zooms the opened image on scroll
   (trackpad) and pans it with the mouse; those events are stopped before they reach the zoom
   element, so the image just shows large and can be saved with right-click. */
(function () {
  'use strict';
  function inViewer(e) {
    var t = e.target;
    return !!(t && t.closest && t.closest('xo-gallery-portal xo-image-zoom'));
  }
  ['wheel', 'mousemove', 'dblclick'].forEach(function (type) {
    window.addEventListener(type, function (e) {
      if (inViewer(e)) e.stopImmediatePropagation();
    }, { capture: true, passive: true });
  });
})();

/* 30 Sep – product page sticky gallery: when the gallery is taller than the space under the
   header, pin it by its bottom edge instead, so the thumbnails are never hidden. */
(function () {
  function fit() {
    var g = document.querySelector('.main-product__image-sticky');
    if (!g) return;
    if (window.innerWidth < 990) { g.style.removeProperty('--wspr-gal-top'); return; }
    var hd = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--ws-hd-h')) || 76;
    var top = hd + 16;
    var room = window.innerHeight - 16;
    var h = g.getBoundingClientRect().height;
    g.style.setProperty('--wspr-gal-top', (h + top > room ? Math.round(room - h) : top) + 'px');
  }
  function init() {
    fit();
    var g = document.querySelector('.main-product__image-sticky');
    if (g && 'ResizeObserver' in window) new ResizeObserver(fit).observe(g);
  }
  window.addEventListener('resize', fit);
  window.addEventListener('load', fit);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();

/* 30 Sep – mobile collection/search: "Sort" text button next to "Filter" in the sticky bar.
   Uses a native select (phone picker), options mirror the theme's sort_by radios; choosing one reloads with ?sort_by=. */
(function () {
  var ICON = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" aria-hidden="true"><path d="M7 4v16M7 20l-3-3M7 20l3-3M17 20V4M17 4l-3 3M17 4l3 3"/></svg>';
  function build() {
    var box = document.querySelector('.xo-facets-drawer--mobile');
    if (!box || box.querySelector('.wspr-msort')) return;
    var radios = [].slice.call(document.querySelectorAll('input[name="sort_by"]'));
    if (!radios.length) return;
    var seen = {}, opts = [];
    radios.forEach(function (r) {
      if (seen[r.value]) return;
      seen[r.value] = 1;
      var l = (r.closest('label') || r.parentElement).textContent.trim();
      opts.push([r.value, l, r.checked]);
    });
    var cur = new URL(location.href).searchParams.get('sort_by');
    var w = document.createElement('label');
    w.className = 'wspr-msort';
    var sel = document.createElement('select');
    sel.setAttribute('aria-label', 'Sort');
    opts.forEach(function (o) {
      var op = document.createElement('option');
      op.value = o[0];
      op.textContent = o[1];
      if (cur ? o[0] === cur : o[2]) op.selected = true;
      sel.appendChild(op);
    });
    w.innerHTML = ICON + '<span>Sort</span>';
    w.appendChild(sel);
    sel.addEventListener('change', function () {
      var u = new URL(location.href);
      u.searchParams.set('sort_by', sel.value);
      u.searchParams.delete('page');
      location.href = u.toString();
    });
    box.appendChild(w);
  }
  function init() {
    build();
    var t;
    new MutationObserver(function () { clearTimeout(t); t = setTimeout(build, 60); }).observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();

/* 1 Oct – policy pages: label, switcher between the store's policies, contents list with the current
   section highlighted, and a help strip at the end of the glass panel. Styles in wspr-ux.css. */
(function () {
  function init() {
    var c = document.querySelector('.shopify-policy__container');
    if (!c || c.getAttribute('data-wspr-pol')) return;
    c.setAttribute('data-wspr-pol', '1');
    var title = c.querySelector('.shopify-policy__title');
    var body = c.querySelector('.shopify-policy__body');
    if (!title || !body) return;

    var label = document.createElement('p');
    label.className = 'wspr-pol__label';
    label.textContent = 'The fine print';
    title.parentNode.insertBefore(label, title);

    // switcher: the footer's policy links (only policies that exist) + contact information
    var links = [].slice.call(document.querySelectorAll('.wspr-ft__policies a')).map(function (a) {
      return [a.textContent.trim(), a.getAttribute('href')];
    });
    links.push(['Company', '/policies/contact-information']);
    var here = location.pathname.replace(/\/$/, '');
    var tabs = document.createElement('nav');
    tabs.className = 'wspr-pol__tabs';
    tabs.setAttribute('aria-label', 'Policies');
    links.forEach(function (l) {
      var a = document.createElement('a');
      a.href = l[1];
      a.textContent = l[0];
      if (here === l[1].replace(/\/$/, '')) a.setAttribute('aria-current', 'page');
      tabs.appendChild(a);
    });
    title.parentNode.insertBefore(tabs, title.nextSibling);

    // contents list from the h2s
    var heads = [].slice.call(body.querySelectorAll('h2'));
    var grid = document.createElement('div');
    grid.className = 'wspr-pol__grid';
    body.parentNode.insertBefore(grid, body);
    var toc = document.createElement('nav');
    toc.className = 'wspr-pol__toc';
    toc.setAttribute('aria-label', 'On this page');
    grid.appendChild(toc);
    grid.appendChild(body);
    if (heads.length > 1) {
      var k = document.createElement('p');
      k.className = 'wspr-pol__toc-k';
      k.textContent = 'On this page';
      toc.appendChild(k);
      heads.forEach(function (h, i) {
        if (!h.id) h.id = 'section-' + (i + 1);
        var a = document.createElement('a');
        a.href = '#' + h.id;
        a.innerHTML = '<span>' + (i < 9 ? '0' : '') + (i + 1) + '</span>';
        a.appendChild(document.createTextNode(h.textContent.trim()));
        toc.appendChild(a);
      });
      var tl = [].slice.call(toc.querySelectorAll('a'));
      function mark() {
        var y = (parseInt(getComputedStyle(document.documentElement).getPropertyValue('--ws-hd-h'), 10) || 76) + 60, on = 0;
        heads.forEach(function (h, i) { if (h.getBoundingClientRect().top <= y) on = i; });
        var last = heads[heads.length - 1].getBoundingClientRect();
        if (last.top < window.innerHeight * 0.6 && (window.innerHeight + window.scrollY) >= document.documentElement.scrollHeight - 700) on = heads.length - 1;
        tl.forEach(function (a, i) { a.classList.toggle('is-on', i === on); });
      }
      window.addEventListener('scroll', mark, { passive: true });
      mark();
    } else {
      grid.style.gridTemplateColumns = '1fr';
      toc.remove();
    }

    // help strip
    var help = document.createElement('div');
    help.className = 'wspr-pol__help';
    help.innerHTML = '<p>Questions about this? Whisper to us.</p><div>' +
      '<a class="is-wa" href="https://wa.me/971585756806?text=' + encodeURIComponent('Hi WSPR, I have a question about your ' + (title.textContent || 'policy').trim().toLowerCase() + ': ') + '" target="_blank" rel="noopener">WhatsApp</a>' +
      '<a class="is-mail" href="mailto:info@letswspr.com">info@letswspr.com</a></div>';
    body.appendChild(help);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
